












import Vue from "vue";

interface Props {
  label: string;
  hints: string[];
}

export default Vue.extend<Props>({
  name: "JzChatHint",
  functional: true,
  props: {
    label: { type: String, default: "Keywords: " },
    hints: { type: Array, default: () => [] }
  }
});
